import { PostCheckoutMandatoryQuestionsInAppVariant } from '../../constants/statsig';
import { CheckoutState } from '../../state';
import { getPostCheckoutMandatoryQuestionsInApp } from '../../utils/statsig/getPostCheckoutMandatoryQuestionsInApp';
import { isNativeApp } from '../app';
import { isSalesClient } from '../event';
import {
    getIsPostCheckoutMandatoryQuestionsSupported,
    hasOfflinePaymentMethods,
} from '../order/typedOrderSelectors';
import { getIsOrganizationExcludedFromPostCheckoutMandatoryQuestions } from '../splitio';
import { hasInventoryQuestions } from '../survey/hasInventoryQuestions';
import { hasRequiredCustomQuestions } from '../survey/hasRequiredCustomQuestions';
import { hasTaxQuestions } from '../survey/hasTaxQuestions';
import { hasWaiverQuestions } from '../survey/hasWaiverQuestions';

export const getAreMandatoryCustomQuestionsAskedAfterPayment = (
    state: CheckoutState,
) => {
    const shouldShowMandatoryCustomQuestionsAfterPaymentInWeb =
        !isNativeApp(state) &&
        !hasWaiverQuestions(state) &&
        !hasTaxQuestions(state) &&
        !hasOfflinePaymentMethods(state) &&
        !hasInventoryQuestions(state) &&
        !isSalesClient(state) &&
        getIsPostCheckoutMandatoryQuestionsSupported(state) &&
        hasRequiredCustomQuestions(state);

    const shouldShowMandatoryCustomQuestionsAfterPaymentInApp =
        getPostCheckoutMandatoryQuestionsInApp() ===
        PostCheckoutMandatoryQuestionsInAppVariant.customQuestionsInApp;

    const isOrganizationExcluded =
        getIsOrganizationExcludedFromPostCheckoutMandatoryQuestions(state);

    return (
        !isOrganizationExcluded &&
        (shouldShowMandatoryCustomQuestionsAfterPaymentInWeb ||
            shouldShowMandatoryCustomQuestionsAfterPaymentInApp)
    );
};
